import {
  IBollettino,
  IRequestBooking,
  IRequestBookingHistory,
  IRequestDeleteBook,
  IRequestReport,
  IResponseBooking,
  IResponseDeleteBook,
  IResponseReport,
} from 'interfaces/models.interface'
import { apiClientService } from '.'
const BASE_PRENOTATION_URL = 'Prenotazioni/'

const book = (
  requestBooking: IRequestBooking,
  setSuccess: (data: IResponseBooking) => void,
  setError: (data: IResponseBooking) => void,
) => {
  return apiClientService.baseApiCall(
    BASE_PRENOTATION_URL + 'Prenota',
    'post',
    undefined,
    requestBooking,
    (res) => setSuccess(res),
    (res) => setError(res),
  )
}
const bookingHistory = (searchParams: IRequestBookingHistory, setSuccess: (data: any) => void, setError?: (error: string) => void) => {
  return apiClientService.baseApiCall(
    BASE_PRENOTATION_URL + 'GetPrenotazioni',
    'get',
    searchParams,
    undefined,
    (res) => setSuccess(res),
    (error) => !!setError && setError(error),
  )
}
const deleteBook = (
  requestDeleteBook: IRequestDeleteBook,
  setSuccess?: (data: IResponseDeleteBook) => void,
  setError?: (data: IResponseDeleteBook) => void,
) => {
  return apiClientService.baseApiCall(
    BASE_PRENOTATION_URL + 'DeletePrenotazione',
    'delete',
    requestDeleteBook,
    undefined,

    (res) => !!setSuccess && setSuccess(res),
    (res) => !!setError && setError(res),
  )
}
const report = (requestReport: IRequestReport, setSuccess?: (data: IBollettino) => void, setError?: (data: IResponseReport) => void) => {
  return apiClientService.baseApiCall(
    BASE_PRENOTATION_URL + 'GetBollettino',
    'get',
    requestReport,
    undefined,
    (res) => !!setSuccess && setSuccess(res),
    (res) => !!setError && setError(res),
    undefined,
  )
}

export const bookingService = { book, bookingHistory, deleteBook, report }
